import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IconStylesPipe } from './pipes/icon-styles.pipe';
import { DriverscamIconComponent } from './driverscam-icon/driverscam-icon.component';
import { DifficultQuestionIconComponent } from './difficult-question-icon/difficult-question-icon.component';
import { GuidanceIconComponent } from './guidance-icon/guidance-icon.component';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        IconStylesPipe,
        DriverscamIconComponent,
        GuidanceIconComponent,
        DifficultQuestionIconComponent,
    ],
    exports: [
        DriverscamIconComponent,
        GuidanceIconComponent,
        DifficultQuestionIconComponent,
    ],
})
export class SharedUiIconsModule {}
